import { createContext, useCallback, useContext, useState } from "react"

export type FiltersDataType = {
  items: Record<string, any>[]
  loading?: boolean
}

export type FiltersDataContextType = {
  data: Record<string, FiltersDataType>
  onChange: (filter: string, value: FiltersDataType) => void
}

export const FiltersDataContext = createContext<FiltersDataContextType>(null)
export const useFilterDataContext = () => useContext(FiltersDataContext)

const FiltersDataProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<Record<string, FiltersDataType>>({})

  const onChange = useCallback((filter: string, value: FiltersDataType) => {
    setData(prev => ({
      ...prev,
      [filter]: value
    }))
  }, [])

  return (
    <FiltersDataContext.Provider value={{ data, onChange }}>
      {children}
    </FiltersDataContext.Provider>
  )
}

export default FiltersDataProvider
